import React, { FC } from "react";
import { Field } from "react-final-form";
import { Theme } from "@material-ui/core/styles";
import { makeStyles, Typography } from "@material-ui/core";
import BootstrapInput from "../../../../components/BootstrapInput";
import FontIcon from "../../../../components/FontIcon";

const useStyles = makeStyles((theme: Theme) => ({
  mainText: {
    fontWeight: "bold",
    marginBottom: 16,
  },
  warningCnt: {
    display: "flex",
    columnGap: "10px",
    marginTop: 10,
    alignItems: "center",
    "& > p": {
      fontSize: 14,
      color: "#a1a4ac",
    },
  },
  warningIcon: {
    color: theme.palette.error.main,
    fontSize: 20,
  },
  reasonCnt: {
    height: 150,
  },
}));

const Content: FC = () => {
  const classes = useStyles();

  return (
    <form>
      <div>
        <Typography className={classes.mainText}>
          Are you sure you want to cancel this application?
        </Typography>
        <div className={classes.reasonCnt}>
          <Field
            required={true}
            fullWidth
            type="text"
            label={`Cancellation reason`}
            placeholder="Please enter cancellation reason to inform school"
            multiline={true}
            rows={5}
            component={BootstrapInput}
            name={"reason"}
          />
        </div>
        <div className={classes.warningCnt}>
          <FontIcon name={"warning"} className={classes.warningIcon} />
          <Typography>
            After cancellation you will not be able to restore it.
          </Typography>
        </div>
      </div>
    </form>
  );
};

export default Content;
